import { FetchParams, Middleware, RequestContext } from '@/api/generated'
import { Injector } from '@/config/dependency-injection'
import { randomInt } from '@/shared/utils/random'
import { loggerFor } from '@/shared/utils/logger'
import { DevelopmentService } from '@/shared/development/development-service'

export class DelayMiddleware implements Middleware {
  private logger = loggerFor('DelayMiddleware')

  private developmentService = Injector.get(DevelopmentService)

  public pre(context: RequestContext): Promise<FetchParams | void> {
    const delay = this.developmentService.getSettings().delay

    return new Promise<FetchParams | void>(resolve => {
      if (delay.active) {
        const milliseconds = randomInt(delay.min, delay.max)

        this.logger.debug(`Delaying ${context.url} by ${milliseconds}ms`)

        setTimeout(() => {
          this.logger.debug(`Calling ${context.url}`)

          resolve(context)
        }, milliseconds)
      } else {
        resolve(context)
      }
    })
  }
}
